module.exports = __webpack_public_path__ + "static/media/lock.600ee00e.svg";